<template>
    <div class="w-full h-full p-2 flex flex-col border shadow-md">
        <div v-if="isEditable">
            <EditClientTransactionForm :transaction="transaction" :client="client" :companies="companies" @edit-transaction="editTransaction" @close="closeEdit"/>
        </div>
        <div v-else  class="w-full h-full">
            <div class="w-full flex justify-end space-x-2 mb-1">
                <button 
                            class="bg-none border border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap flex justify-center items-center rounded-md"
                        >
                    <EditSVG @click="openEdit" stroke="white" /> 
                </button>
                <button
                    v-if="isLoading"
                    disabled 
                    class="border border-gray-400  bg-gray-400 whitespace-nowrap flex justify-center items-center rounded-md"
                >
                    <InfiniteSpinnerSVG icon-class="h-4" />
                </button>
                        <button v-else 
                            class="bg-none border border-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 text-white bg-dark-secondary whitespace-nowrap flex justify-center items-center rounded-md"
                        >
                        <TrashSVG fill="white" />  
                        </button>
            </div>
            <div class="flex flex-col h-full w-full">
                <div class="flex w-full justify-between ">
                    <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800">
                        Target Company:
                    </div>
                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>           
                    <div class=" flex flex-wrap gap-1 pb-1 justify-between tracking-wide items-center">
                        <div class="font-semibold text-black">
                            {{ companyName }}
                        </div>
                    </div>
                </div>
                <div class="flex">
                    <div class="flex flex-col justify-start w-full mb-2">
                        <div class="flex w-full justify-between ">
                            <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800">
                                Transaction Date:
                            </div>
                            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>           
                            <div class=" flex flex-wrap gap-1 pb-1 justify-between tracking-wide items-center">
                                <div class="font-semibold text-black">
                                    {{ transactionDate }}
                                </div>
                            </div>
                        </div>
                    </div>
                <div v-if="transaction.google_drive_tombstone_link" class="w-1/4 ml-1" >
                    <div class="h-full w-full flex justify-center">
                        <iframe :src="transaction.google_drive_tombstone_link" class="h-full w-20" :style="{'background-color': 'transparent'}" allowtransparency="true" allow="autoplay"></iframe>
                    </div>
                </div>
                </div>
                <div v-if="transaction.contingency_payments.length > 0" class="flex w-full border-b mb-2">
                    Contingency Payments
                </div>
                <div class="w-full grid grid-cols-2 gap-1">
                    <div v-for="payment in transaction.contingency_payments" :key="payment.id" :class="statusStyle(payment)" class="border shadow-md flex flex-col p-1">
                        <div class="flex">
                            Payment date: {{ payment.payment_date }}
                        </div>
                        <div class="flex">
                            Status: <span>&nbsp;{{ payment.status }}</span> 
                        </div>
                        <div class="flex overflow-auto h-20 text-sm">
                            {{ payment.contingency_description }}
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <!-- <div class="flex w-full">

        </div> -->
    </div>
</template>

<script setup>
import { defineProps, computed, ref, defineEmits } from 'vue';
import { formatDateTwoDigitYear } from '@/composables/formatDate';
import EditSVG from '@/components/svg-components/EditSVG.vue';
import { updateClientTransaction } from '@/services/ClientTransaction';
import InfiniteSpinnerSVG from '@/components/svg-components/InfiniteSpinnerSVG.vue';
import TrashSVG from '@/components/svg-components/TrashSVG.vue';
import EditClientTransactionForm from './EditClientTransactionForm.vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';

const props = defineProps(['transaction', 'client', 'companies'])
const emit = defineEmits(['refetch-clients'])
const store = useStore()
const $toast = useToast()

const isLoading = ref(false)

const isEditable = ref(false)

function openEdit(){
    isEditable.value = true
}

async function editTransaction(data) {
    isLoading.value = true
    const token = store.state.auth.token
    const result = await updateClientTransaction(token, props.transaction.id, data)
    if(result.status == 200){
        emit('refetch-clients')
        $toast.open({
            message: 'Successfully updated transaction',
            type: 'success',
            duration: 3000
        })
        isLoading.value = false
        closeEdit()
    } else {
        $toast.open({
            message: 'Error, could not update transaction',
            type: 'error',
            duration: 3000
        })
    }
}

function closeEdit(){
    isEditable.value = false
}

const companyName = computed(() => {
    return props.transaction ? props.transaction.target_company ? props.transaction.target_company.company_name : '--' : '--'
})

const transactionDate = computed(() => {
    return props.transaction ? formatDateTwoDigitYear(props.transaction.transaction_date) : '--'
})

const statusStyle = (payment) => {
    if(payment.status == 'pending'){
        return 'bg-yellow-200'
    }
    if(payment.status == 'paid'){
        return 'bg-green-200'
    }
    if(payment.status == 'lost'){
        return 'bg-red-200'
    }
    return ''
}


</script>